import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
  className?: string;
  type?: 'button' | 'submit';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  href,
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wider rounded relative overflow-hidden transition-all duration-100';
  const variants = {
    primary: 'bg-word-spoken text-word-error shadow-[0_2px_0_0_#998360] hover:shadow-[0_1px_0_0_#998360] hover:translate-y-[1px] active:shadow-none active:translate-y-[2px]',
    secondary: 'bg-word-current text-word-error shadow-[0_2px_0_0_#998360] hover:shadow-[0_1px_0_0_#998360] hover:translate-y-[1px] active:shadow-none active:translate-y-[2px]',
    outline: 'bg-white text-m3-on-surface border-4 border-m3-on-surface shadow-[0_0_20px_rgba(13,112,128,0.2)] hover:bg-m3-on-surface hover:text-white hover:shadow-[0_0_30px_rgba(13,112,128,0.3)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-11">{children}</span>
      <motion.div className="absolute inset-0 bg-white opacity-0" whileHover={{
      opacity: 0.1
    }} transition={{
      duration: 0.2
    }} data-id="element-12" />
    </>;
  if (href) {
    return <motion.a href={href} className={classes} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-13">
        {content}
      </motion.a>;
  }
  return <motion.button type={type} onClick={onClick} className={classes} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-14">
      {content}
    </motion.button>;
}